import { Injectable, inject } from '@angular/core'
import { Filter, HttpParamsBuilder, RestClientList } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { TracedMaterial } from './tracedmaterial/traced-material'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'
import { TracedMaterialUpdate } from './traced-material-update'

export class BatchTracingFilter {
  public static workBatchId(workBatchId: string): Filter {
    return new Filter('workBatchId', workBatchId)
  }

  public static workCenterId(workCenterId: string): Filter {
    return new Filter('workCenterId', workCenterId)
  }
}

@Injectable({
  providedIn: 'root',
})
export class BatchTracingService extends RestClientList<TracedMaterial, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/batch-tracing', http, {
      idField: 'id',
    })
  }

  public load(filters: Filter[]): Observable<TracedMaterial[]> {
    return this.http.get<any>(this.restEndpoint, {
      params: HttpParamsBuilder.start().appendFilters(filters).build(),
    })
  }

  public saveAll(tracingUpdates: TracedMaterialUpdate[]): Observable<void> {
    return this.http.patch<any>(this.restEndpoint, tracingUpdates)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/
}
